import { STRINGS } from 'config';
import _startsWith from 'lodash/startsWith';
import { apiPostSubmit } from 'common/apiRequests';
import _isNil from 'lodash/isNil';
import _omitBy from 'lodash/omitBy';
import { clearSessionTimeout } from '../session';

const consultation = STRINGS.CONSULTATION_REDUCER;

export const submitETriageConsultation = () => (dispatch, getState) => {
  dispatch({ type: consultation.SUBMIT_CONSULTATION_REQUEST });
  const { sessionId } = getState().consultationReducer;
  const embeddedSubmitInput = document.getElementById('sessionId');
  const embeddedSubmitButton = document.getElementById('submit');
  if (embeddedSubmitInput && embeddedSubmitButton) {
    embeddedSubmitInput.value = sessionId;
    embeddedSubmitButton.click();
    return dispatch({ type: 'consultation/EMBEDDED_SUBMIT_FORM_SUBMITTED' });
  }
  return dispatch({ type: 'consultation/UNABLE_TO_FIND_EMBEDDED_SUBMIT_FORM' });
};

export const submitPrimaryCareConsultation = () => (dispatch, getState) => {
  dispatch({ type: consultation.SUBMIT_CONSULTATION_REQUEST });
  const { sessionId, practice, twoWayMessageId } = getState().consultationReducer;
  const requestBody = _omitBy(
    {
      sessionId: sessionId,
      source: 'WEB_APP',
      twoWayMessageId: twoWayMessageId || null,
    },
    _isNil,
  );
  apiPostSubmit(practice.practiceId)
    .send(requestBody)
    .retry(3, error => {
      if (error) {
        dispatch({ type: `${consultation.SUBMIT_CONSULTATION_REQUEST}_RETRY` });
      }
    })
    .then(response => {
      if (!response.body) {
        dispatch({
          type: consultation.SUBMIT_CONSULTATION_ERROR,
          payload: 'SUBMIT_CONSULTATION_ERROR: No response body',
        });
      } else if (_startsWith(response.body.errorMessage, 'Duplicate submission')) {
        dispatch({ type: consultation.DUPLICATE_SUBMISSION_ERROR, payload: response.body });
      } else if (response.body.errorCode || response.body.errorMessage) {
        dispatch({
          type: consultation.SUBMIT_CONSULTATION_ERROR,
          payload: response.body,
        });
      } else {
        dispatch({ type: consultation.SUBMIT_CONSULTATION_SUCCESS, payload: response.body });
        window?.workflowFrontendIntegration?.setEndScreenStateFlag(true);
        dispatch(clearSessionTimeout());
      }
    })
    .catch(error => {
      dispatch({ type: consultation.SUBMIT_CONSULTATION_ERROR, payload: error });
    });
};
